<script>
import Layout from '@/Shared/Layout'
export default {
  layout: Layout,
}
</script>

<script setup>
import { onMounted, onUnmounted, reactive, provide } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { filterOnlyUnique, replaceSpecials, formatYen, removeLineBreaks } from '@/Shared/helper.js'
import ExtendProductVideo from '@/Pages/Brand/ExtendProductVideo'
import ExtendRockySpecElement from '@/Pages/Brand/ExtendRockySpecElement'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  brandInfo:Array,
  myCategories: Object,
  myCategoriesColumns: Object,
  v3year: String,
  v3category: String,
  myProducts: Array,
  pref: Object,
})

provide('data', props.brandInfo[0])

const currentProducts = reactive(
  {
    menustats: false,
    focus: -1,
  },
)
const getCategoryName = function (slug){
  const l = props.myCategories[props.v3year].filter(i => i.slug == slug)
  return l[0].name
}
const getCategoryGeometry = function (slug) {
  const l = props.myCategories[props.v3year].filter(i => i.slug == slug)
  return l[0].geometry
}
const getCategoryExtraSpecTable = function (slug) {
  const l = props.myCategories[props.v3year].filter(i => i.slug == slug)
  return l[0].extra_spec_table
}
// join s3 path from DB and productImage
const generateImgPath = function (img) {
  const r = props.brandInfo[0].brandPMSs3path + props.v3year + '/500/' + img
  return r
}
const generateSubCategories = function () {
  let r = []
  let t = []
  const subcategories = props.myProducts.filter(i => i.productYear == props.v3year && i.productCategoryMain == props.v3category && i.productCategorySub != '')
  subcategories.forEach((item) => { t.push(item.productCategorySub) } )
  if ( t.length >= 1 ){
    r = t.filter(filterOnlyUnique)
  }
  return r
}
const scrollToAnchor = function(anchor){
  var el = document.querySelector('#anchor-' + replaceSpecials(anchor) )
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
const filterProductByYearAndCategory = function () {
  const subcategories = props.myProducts.filter(i => i.productYear == props.v3year && i.productCategoryMain == props.v3category)
  return subcategories
}
const filterProductByYearAndCategoryAndSub = function (sub) {
  const subcategories = props.myProducts.filter(i => i.productYear == props.v3year && i.productCategoryMain == props.v3category && i.productCategorySub == sub)
  return subcategories
}
const openSpec = function(e){
  currentProducts.focus = e
  setTimeout(function () {
    var el = document.querySelector('#produt-table-' + e)
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, 10)

}
const toGeometry = function(){
  var el = document.querySelector('#specs')
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const generateSpecLoop = function(str){
  const reg = /[a-z]+$/gm
  let temp = str.split(reg)
  let ret = []
  temp.forEach( (each)=> {
    let splitarray = each.split('：')
    let toAdd= {}
    if (splitarray[0] != '' && splitarray[1] != '') {
      toAdd.label = stripslashes(removeLineBreaks(splitarray[0]))
      toAdd.content = stripslashes(removeLineBreaks(splitarray[1]))
      ret.push(toAdd)
    }
  })
  return ret
}

onMounted(() => {})
onUnmounted(() => {})
</script>

<template>
  <div id="brandDetail_v2" class="product_detail">
    <div class="contentsContainer">
      <Breadcrumbs class="!flex !m-0 w-full" category="brand" :slug="props.brandInfo[0].brandSlug" :title="props.brandInfo[0].brandNameLocal" />

      <div class="brand-products product-advance-wrap max-w-[800px] mx-auto">
        <header>
          <h1 class="category-title" v-html="getCategoryName(v3category)" />
        </header>
        
        <!-- <ul v-if="generateSubCategories().length >= 1" class="subcategories">
          <li v-for="subcate in generateSubCategories()" :key="subcate">
            <ButtonRounded class="subcategories-btn" :text="subcate" @click="scrollToAnchor(subcate)" />
          </li>
        </ul> -->

        <section v-if="generateSubCategories().length >= 1" class="product-section">
          <div v-for="subcate in generateSubCategories()" :id="'anchor-' + replaceSpecials(subcate)" :key="subcate" class="each-category">
            <div v-for="p in filterProductByYearAndCategoryAndSub(subcate)" :key="p" class="each mb-20 sm:mb-28 md:mb-36">
              <div class="mx-auto sm:mt-0 md:mt-0 lg:mt-0 text-center">
                <div class="name">
                  <h3 class="product-name">{{ p.productNameJ }}</h3>
                  <h4 class="product-name-en">{{ p.productName }}</h4>
                </div>
                <img :src="generateImgPath(p.productImage)" :alt="p.productNameJ" class="my-10" />

                <div class="max-w-[740px] mx-auto">
                  <p class="text-center text-sm sm:text-lg md:text-xl mb-5">
                    {{ p.productColor }}
                  </p>
                  <p class="price">
                    <span v-html="formatYen(p.productPrice)" />
                    <span class="jp text-[75%]">（税込）</span>
                  </p>
                  <p class="text-left !mb-10">
                    {{ p.productInfo }}
                  </p>
                  <template v-if="brandInfo[0].brandSlug === 'rocky_mountain_bicycles'">
                    <ul class="flex flex-wrap sm:flex-nowrap items-center justify-center [&>li]:w-full sm:[&>li]:w-1/2 gap-6">
                      <li><ButtonRounded class="btn-more-info" icon="arrow" :text="'スペックを見る'" @click="openSpec(p.productID)" /></li>
                      <li><ButtonRounded class="btn-more-spec" icon="arrow" :text="'ジオメトリーを見る'" @click="toGeometry()" /></li>
                    </ul>
                  </template>
                  <template v-else>
                    <ButtonRounded class="btn-more-info xs:max-w-[220px] mx-auto" icon="arrow" :text="'スペックを見る'" @click="openSpec(p.productID)" />
                  </template>
                </div>

                <div :id="'produt-table-' + p.productID" class="scroll-mt-[80px] md:scroll-mt-[100px] xl:scroll-mt-[40px]">
                  <div class="product-table max-w-[740px] mx-auto" :class="{ on: currentProducts.focus === p.productID }">
                    <table>
                      <tbody>
                        <tr>
                          <th>モデル</th>
                          <td>{{ p.productNameJ }}</td>
                        </tr>
                        <tr>
                          <th>品番</th>
                          <td>{{ p.AFID }}</td>
                        </tr>
                        <tr>
                          <th>価格</th>
                          <td v-html="formatYen(p.productPrice)" />
                        </tr>
                        <tr>
                          <th>サイズ</th>
                          <td>{{ p.productSize }}</td>
                        </tr>
                        <tr v-for="tr in generateSpecLoop(p.productSpec)" :key="tr">
                          <th>{{ tr.label }}</th>
                          <td>{{ tr.content }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <template v-if="getCategoryGeometry(v3category).length">
          <section id="specs" class="max-w-[740px] mx-auto scroll-mt-[80px] md:scroll-mt-[100px] xl:scroll-mt-[40px]">
            <div class="rounded-[20px] overflow-hidden">
              <div v-for="g in getCategoryGeometry(v3category)" :key="g">
                <img :src="g" alt="" class="mx-auto block" />
              </div>
            </div>
          </section>
        </template>

        <section v-if="getCategoryExtraSpecTable(v3category)" class="max-w-[740px] mx-auto">
          <ExtendRockySpecElement />
        </section>

        <ExtendProductVideo :my-products="filterProductByYearAndCategory()" />

        <div class="mt-12 sm:mt-14 md:mt-16 lg:mt-20">
          <Link class="w-auto" :href="`/brands/${brandInfo[0].brandSlug}#brand-products`">
            <button class="block text-[13px] md:text-[14px] py-4">
              <Icon type="arrow" class="scale-x-[-1] inline-block -mt-[2px] mr-[2px]" />
              商品一覧のトップに戻る
            </button>
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>
